import { normalizeDateToYyyyMmDd } from "../SafetyObservation/observationUtils";

export const INITIAL_HSE_POLICY_FORM_DATA = {
  title: "",
  category: "",
  description: "",
  effective_date: "",
};

export const formatPolicyDateForInput = (dateValue) =>
  normalizeDateToYyyyMmDd(dateValue);

export const buildHsePolicyFormData = (formData, documents = []) => {
  const payload = new FormData();

  payload.append("title", formData.title.trim());
  payload.append("category", formData.category.trim());
  payload.append("description", formData.description.trim());
  payload.append(
    "effective_date",
    normalizeDateToYyyyMmDd(formData.effective_date),
  );

  documents.forEach((document) => {
    if (document instanceof File) {
      payload.append("documents", document);
    }
  });

  return payload;
};

export const isExistingPolicyDocument = (document) => Boolean(document?.id);

export const getPolicyDocumentName = (document) =>
  document?.filename || document?.name || "Document";

export const getPolicyDocumentSizeLabel = (document) => {
  if (document instanceof File) {
    return `${(document.size / 1024).toFixed(2)} KB`;
  }

  const numericSize = Number(document?.file_size);
  if (!Number.isNaN(numericSize) && numericSize > 0) {
    return `${numericSize.toFixed(2)} KB`;
  }

  if (typeof document?.file_size === "string" && document.file_size.trim()) {
    return document.file_size;
  }

  return "Size unavailable";
};

export const getPolicyDescriptionPreview = (value, maxLength = 70) => {
  if (!value) return "NA";
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength)}...`;
};
